import { motion } from "framer-motion";
import { Wallet, Brain, ShoppingCart, AlertCircle } from "lucide-react";

const stats = [
  {
    percentage: "84",
    description: "of people exceed their monthly budget",
    icon: Wallet,
    source: {
      name: "NERDWALLET",
      url: "https://www.nerdwallet.com/article/finance/data-2023-budgeting-report"
    }
  },
  {
    percentage: "73",
    description: "of Americans rank finances as the #1 source of stress",
    icon: Brain,
    source: {
      name: "CNBC",
      url: "https://www.cnbc.com/select/73-percent-of-americans-rank-finances-as-the-number-one-stress-in-life/"
    }
  },
  {
    percentage: "77",
    description: "of Americans feel anxious about their money",
    icon: AlertCircle,
    source: {
      name: "CNBC",
      url: "https://www.cnbc.com/select/how-to-take-control-of-your-finances/"
    }
  },
  {
    value: "$3,381",
    description: "what the average consumer's impulse spend per year",
    icon: ShoppingCart,
    source: {
      name: "CAPITAL ONE",
      url: "https://capitaloneshopping.com/research/impulse-buying-statistics/"
    }
  }
];

export default function Stats() {
  return (
    <section className="py-24 px-4 bg-white">
      <div className="container max-w-6xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl md:text-5xl font-black font-display text-[#FF7063] mb-6">
            If Budgeting Worked<br/>
            These Wouldn't Be the Stats
          </h2>
        </motion.div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {stats.map((stat, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              viewport={{ once: true }}
              className="bg-gray-100 rounded-lg p-12 text-center relative group cursor-pointer"
              whileHover="hover"
            >
              {/* Background Icon with hover animation */}
              <motion.div 
                className="absolute inset-0 flex items-center justify-center opacity-5 pointer-events-none"
                variants={{
                  hover: {
                    scale: 1.2,
                    rotate: 5,
                    opacity: 0.1,
                    transition: {
                      duration: 0.3,
                      ease: "easeOut"
                    }
                  }
                }}
              >
                <stat.icon className="w-32 h-32" />
              </motion.div>

              {/* Content with hover animation */}
              <motion.div 
                className="relative z-10"
                variants={{
                  hover: {
                    y: -5,
                    transition: {
                      duration: 0.3,
                      ease: "easeOut"
                    }
                  }
                }}
              >
                <motion.div 
                  className="text-5xl md:text-6xl font-bold text-[#2D3436] mb-4"
                  variants={{
                    hover: {
                      color: "#FF7063",
                      transition: {
                        duration: 0.3
                      }
                    }
                  }}
                >
                  {stat.value || `${stat.percentage}%`}
                </motion.div>
                <motion.p 
                  className="text-lg text-[#235D62]"
                  variants={{
                    hover: {
                      color: "#FF7063",
                      transition: {
                        duration: 0.3
                      }
                    }
                  }}
                >
                  {stat.description}
                </motion.p>
              </motion.div>

              {/* Source citation - positioned at bottom left */}
              {stat.source && (
                <div className="absolute bottom-4 left-4 text-xs text-gray-500">
                  SOURCE: <a href={stat.source.url} target="_blank" rel="noopener noreferrer" className="hover:text-[#FF7063] transition-colors">{stat.source.name}</a>
                </div>
              )}
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}